import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, NavLink } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Row,
  Col,
  Spin,
  Alert,
} from "antd";
import logofull from "../assets/logo.png";

import { userActions } from "../redux/reducers/user";
import { useHistory} from 'react-router-dom'

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const SignInForm = ({redUrl}) => {  const isLoggedIn = useSelector(
    (state) => state.user.isLoggedIn && state.user.jwt !== null
  );
  const loginError = useSelector((state) => state.user.loginError);
  const isFetching = useSelector((state) => state.user.isFetching);
  const isLoginError = loginError ? true : false;
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(userActions.logOut()); //reset state and clear any errors
  }, [dispatch]);

  const onFinish = (values) => {
    dispatch(userActions.signIn(values));
    history.push(redUrl);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const signInForm = (
    <Form
      {...layout}
      name="basic"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="E-mail"
        name="email"
        rules={[
          {
            required: true,
            message: "Please enter your email!",
            type: "email",
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        style={{marginBottom:0}}
        label="Password"
        name="password"
        rules={[{ required: true, message: "Please enter your password!" }]}
      >
        <Input.Password />
      </Form.Item>
      <Row type="flex" justify="end" align="middle">
        <NavLink to="/forgot-password"> Forgot password?</NavLink>
      </Row>

      <Form.Item {...tailLayout} name="remember" valuePropName="checked">
        <Checkbox>Remember me</Checkbox>
      </Form.Item>

      <Row>
        <Button type="primary" htmlType="submit" block>
          Submit
        </Button>
      </Row>
      <Row type="flex" justify="center" align="middle">
        Don't have account yet?<NavLink to="/register"> Register Now!</NavLink>
      </Row>
    </Form>
  );
    return (
        <>
        {isLoginError && (
          <Alert
            message={loginError}
            type="error"
            closable
            showIcon
            banner
            style={{ position: "absolute", top: "50px" }}
          />
        )}
        <Col>
          <Spin spinning={isFetching} delay={100}>
            <img
              src={logofull}
              alt="Logo"
              className="logo-full"
              style={{ marginBottom: 15 }}
            />
            {signInForm}
          </Spin>
        </Col>
        </>
    )
}

export default SignInForm
